import { useState } from "react";
import { FileSpreadsheet, FileText, Loader2, Table2 } from "lucide-react";
import { toast } from "sonner";
import { download, toParams } from "@/lib/analyse";

/** Exports CONTEXTUELS à l'onglet actif : « export = ce que je vois ». */
export const BarreExports = ({ filtres, onglet }) => {
  const [busy, setBusy] = useState(null);
  const run = async (key, url, extra, ext) => {
    setBusy(key);
    try {
      await download(url, { ...toParams(filtres), onglet, ...extra },
        `prodtrack_${onglet}_${filtres.du}_${filtres.au}.${ext}`);
      toast.success("Export téléchargé");
    } catch (e) {
      toast.error(e.message || "Échec de l'export");
    } finally {
      setBusy(null);
    }
  };
  const B = ({ k, icon: Icon, label, onClick }) => (
    <button data-testid={`export-${k}`} onClick={onClick} disabled={!!busy}
      className="h-8 px-3 text-[11px] font-semibold bg-card border border-border rounded-sm flex items-center gap-1.5 hover:bg-muted disabled:opacity-50 transition-colors">
      {busy === k ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Icon className="h-3.5 w-3.5 text-primary" />}
      {label}
    </button>
  );
  return (
    <div data-testid="barre-exports" className="flex flex-wrap items-center gap-2">
      <B k="excel" icon={FileSpreadsheet} label="Exporter Excel" onClick={() => run("excel", "/analyse/export/excel", {}, "xlsx")} />
      <B k="pdf" icon={FileText} label="PDF synthèse" onClick={() => run("pdf", "/analyse/export/pdf", { format: "synthetique" }, "pdf")} />
      <B k="pdf_detaille" icon={FileText} label="PDF détaillé" onClick={() => run("pdf_detaille", "/analyse/export/pdf", { format: "detaille" }, "pdf")} />
      <B k="csv" icon={Table2} label="Exporter CSV" onClick={() => run("csv", "/analyse/export/csv", {}, "csv")} />
    </div>
  );
};
